export const itemVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.5, ease: 'easeOut' as const }
  }
};

export const achievements = [
  {
    id: 1,
    count: 1000,
    text: 'Участие в съемке подкаста «ЦЭШ»'
  },
  {
    id: 2,
    count: 1500,
    text: 'Ужин в ресторане "MANA" в Минске за счёт ШИЛО'
  },
  {
    id: 3,
    count: 2000,
    text: 'Проходка на футбольный матч Амкал х Majestic'
  },
  {
    id: 4,
    count: 3000,
    text: 'Участие в съемке большого интервью ШИЛО'
  },
  {
    id: 5,
    count: 4000,
    text: 'Пропуск в закулисье GunZone X. Целая серия съёмок и прямая трансляция в киностудии'
  },
  {
    id: 6,
    count: 5000,
    text: 'Приглашение на День Рождения ШИЛО. Самая закрытая вечеринка в GTA сфере'
  }
];
